import { useTable, useRowSelect } from 'react-table';

/*
The useTable instance is documented here:
https://github.com/tannerlinsley/react-table/blob/master/docs/src/pages/docs/api/useTable.md#instance-properties
The useRowSelect instance is documented here:
https://github.com/tannerlinsley/react-table/blob/master/docs/src/pages/docs/api/useRowSelect.md#instance-properties
*/
const useRowSelectTable = ({ columns, data }) => {
  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useRowSelect,
  );
  return { columnsLength: columns.length, ...tableInstance };
};

export default useRowSelectTable;
